<div class="dialog">
  <header class="dialog__header">
    <h3 class="dialog__header__title">{{ 'Category' | translate }} {{ (currentCategory ? 'Edit' : 'Add') | translate | lowercase }}</h3>
    <div class="dialog__header__action-buttons">
      <div (click)="close()" class="dialog__header__action-buttons__button">
        <span>
          <app-icon [cssStyle]="{ 'margin-top': '3px' }" iconName="close" size="14px"></app-icon>
        </span>
      </div>
    </div>
  </header>

  <div class="dialog__content">
    <form [formGroup]="form" action="" class="form">
      <div class="input-group full-width-input">
        <label for="title" translate>Title</label>
        <input [placeholder]="'Enter Title' | translate" class="full-width-input" formControlName="title" id="title" name="title" type="text" />
        <app-form-error [control]="form.get('title')" [name]="'Title' | translate"></app-form-error>
      </div>
      <!-- Description -->
      <div class="input-group">
        <label for="position" translate>Position</label>
        <app-dropdown [options]="positions" formControlName="position" id="position" name="position"></app-dropdown>
        <app-form-error [control]="form.get('position')" [name]="'Position' | translate"></app-form-error>
      </div>
    </form>
  </div>

  <footer>
    <div class="dialog__footer">
      @if (!isMobileView()) {
        <div class="dialog__footer__buttons">
          <app-button (click)="close()" [idleText]="'Cancel' | translate" [inlineStyle]="{ border: '1px solid var(--gray)' }" cssClass="button-simple"></app-button>
          <app-button (clickEvent)="save($event)" [disabled]="form.pristine" [idleText]="(currentFaq ? 'Update' : 'Save') | translate"></app-button>
        </div>
      }
    </div>
    @if (isMobileView()) {
      <div class="mobile-button mx-16">
        <app-button (clickEvent)="save($event)" [disabled]="form.pristine" [idleText]="(currentFaq ? 'Update' : 'Save') | translate" cssClass="button-primary button-full"></app-button>
      </div>
    }
  </footer>
</div>
